import React, { useEffect, useState } from 'react';

function SliderAlertBox() {
  const [isOpen, setIsOpen] = useState(false); 

  const handleToggleAlertBox = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleLinkClick = (event) => {
      event.preventDefault();

      const target = document.querySelector(event.currentTarget.hash);
      const alternativeTarget = document.querySelector(`[name="${event.currentTarget.hash.slice(1)}"]`);

      const selectedTarget = target || alternativeTarget;

      if (selectedTarget) {
        window.scrollTo({
          top: selectedTarget.offsetTop,
          behavior: 'smooth',
        });
      }
    };

    const handleDocumentReady = () => {
      document.querySelectorAll('.slider-alert-box a[href*="#"]:not([href="#"])').forEach((element) => {
        element.addEventListener('click', handleLinkClick);
      });

      setTimeout(() => {
        setIsOpen(true);
      }, 10);

      setTimeout(() => {
        setIsOpen(false);
      }, 13000);
    };

    handleDocumentReady();

    return () => {
      document.querySelectorAll('.slider-alert-box a[href*="#"]:not([href="#"])').forEach((element) => {
        element.removeEventListener('click', handleLinkClick);
      });
    };
  }, []); // Empty dependency array ensures the effect runs once on mount

  const alertBoxClassName = `slider-alert-box${isOpen ? ' open' : ''}`;

  return (
    <div className={alertBoxClassName}>
      <div className="close-alert" onClick={handleToggleAlertBox}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.3 27.3">
          <path d="M26.8,0.4V23h-1.7V3.3L1.4,27.1l-1.2-1.2L24,2.1H4.3V0.4H26.8z"/>
        </svg>
      </div>
      <div className="side-message-copy">
        <strong>Want to learn more?</strong><br />
        We want to connect with you.<br />
        <a className="cta-url" href="#learn-more"><strong>Request More Information</strong></a>
      </div>
    </div>
  );
}

export default SliderAlertBox;